import React from 'react';
import ShareChallengePopup from '../components/ChallengeCard';

const ShareChallengePage = () => {
  return (
    <div className="share-challenge-page">
      <ShareChallengePopup />
    </div>
  );
};

export default ShareChallengePage;
